<template>
<Accordion class="w-full" collapsible>
    <AccordionItem v-for="item in accordionItems" :key="item.value" :value="item.value">
      <AccordionTrigger class="text-left gap-4">{{ item.title }}</AccordionTrigger>
      <AccordionContent>
        <p v-html="item.content"></p>
      </AccordionContent>
    </AccordionItem>
  </Accordion>
</template>

<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { getText } from '@/services/translation.service';
import { computed } from 'vue';

const { isEstimate } = defineProps<{ isEstimate: boolean }>();

const accordionItems = computed(() => isEstimate ?
[
    { value: 'item-1', title: getText(13814), content: getText(13815) },
    { value: 'item-2', title: getText(13816), content: getText(13817) },
    { value: 'item-3', title: getText(13818), content: getText(13819) },
    { value: 'item-4', title: getText(13820), content: getText(13821) },
    { value: 'item-5', title: getText(13822), content: getText(13823) },
    { value: 'item-6', title: getText(13824), content: getText(13825) },
    { value: 'item-7', title: getText(13826), content: getText(13827) },
] :
[
    { value: 'item-1', title: getText(13794), content: getText(13795) },
    { value: 'item-2', title: getText(13796), content: getText(13797) },
    { value: 'item-3', title: getText(13798), content: getText(13799) },
    { value: 'item-4', title: getText(13800), content: getText(13801) },
    { value: 'item-5', title: getText(13802), content: getText(13803) },
    { value: 'item-6', title: getText(13804), content: getText(13805) },
]);
</script>

<style scoped>

</style>
